import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiSmpGptAsk {
}
ApiSmpGptAsk.ask = (params, signal) => apiRequest({
    body: params,
    endpoint: REACT_APP__URL_SMP_API + "/gpt/v1/ask",
    method: "POST",
    signal,
});
//# sourceMappingURL=ask.js.map